import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react';
import { Fragment } from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { FaWhatsapp, FaInstagram } from 'react-icons/fa';

export default function ContactModal({ isOpen, onClose }) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300" 
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200" 
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-60" />
        </TransitionChild>

        <div className="fixed inset-0 overflow-y-auto flex items-center justify-center px-4">
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300" 
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200" 
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <DialogPanel className="relative w-full max-w-[400px] transform overflow-hidden rounded-2xl bg-black text-white p-8 shadow-xl transition-all border border-gray-500 items-center">
              <DialogTitle className="text-2xl font-lato font-semibold text-white mb-6 text-center">
                Get in Touch
              </DialogTitle>
              <div className="space-y-4 text-center">
                <a
                  href="https://wa.me/628122914419"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 bg-green-500 hover:bg-green-700 font-lato font-semibold text-white px-4 py-3 rounded-lg shadow-lg transition mx-10"
                >
                  <FaWhatsapp className="text-2xl" />
                  WhatsApp Us
                </a>
                <a
                  href="mailto:Dimensi.sinergi95@gmail.com"
                  className="flex items-center justify-center gap-2 bg-gray-500 hover:bg-gray-700 font-lato font-semibold text-white px-4 py-3 rounded-lg shadow-lg transition mx-10"
                >
                  <EnvelopeIcon  className="h-5 w-5" />
                  Email Us
                </a>
              </div>

              <div className="mt-6 border-t border-gray-400 pt-4 text-sm text-gray-400">
                {/* Instagram */}
                <div className="flex items-center mb-3 justify-center">
                  <FaInstagram className="mr-2 text-xl" />
                  <a
                    href="https://instagram.com/dimensinergi_electrical"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    @dimensinergi_electrical
                  </a>
                </div>

                {/* Email */}
                <div className="flex items-center justify-center mb-3">
                  <EnvelopeIcon className="mr-2 h-5 w-5 text-gray-300" />
                  <a
                    href="mailto:Dimensi.sinergi95@gmail.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-gray-400 hover:underline"
                  >
                    Dimensi.sinergi95@gmail.com
                  </a>
                </div>

                {/* WhatsApp - multiple numbers */}
                <div className="flex flex-col items-center text-gray-400">
                  <div className="flex items-center mb-1">
                    <FaWhatsapp className="mr-2 text-xl text-green-500" />
                    <a
                      href="https://wa.me/628122914419"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline"
                    >
                      +62 812-2914-419 (Andang)
                    </a>
                  </div>
                  <div className="flex items-center mt-2">
                    <FaWhatsapp className="mr-2 text-xl text-green-500 opacity-100" />
                    <a
                      href="https://wa.me/6281390663000"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline"
                    >
                      +62 813-9066-3000 (Argo)
                    </a>
                  </div>
                </div>
              </div>

              <button
                onClick={onClose}
                className="absolute top-3 right-3 text-white hover:text-red-500 transition"
              >
                ✕
              </button>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
}
